import { Link } from 'react-router-dom';

export default function AboutSection() {
  const credentials = [
    { left: 'Licensed Contractor', right: 'EPA Certified' },
    { left: 'Insured & Bonded', right: 'NALP Member' },
    { left: 'ICPI Certified', right: 'BBB A+ Rated' }
  ];

  return (
    <section className="py-24 bg-[#F5F5F5] relative">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content - Left */}
          <div className="bg-white rounded-3xl p-12 lg:p-16 shadow-xl relative z-10 lg:-mr-20">
            <div className="text-[#E67E22] text-xs font-semibold tracking-[0.2em] uppercase mb-4">
              ABOUT SCAPEWORX
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Built on Craftsmanship, Driven by Excellence
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              For over 15 years, ScapeWorx has been transforming ordinary outdoor spaces into extraordinary living environments throughout Delaware County. Our commitment to quality craftsmanship and personalized service has made us the trusted choice for homeowners who demand the very best.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Every project we undertake reflects our dedication to excellence, from initial design consultation through final installation. We don't just meet expectations—we exceed them.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {credentials.map((row, index) => (
                <div key={index} className="contents">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#E67E22]"></i>
                    <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">{row.left}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#E67E22]"></i>
                    <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">{row.right}</span>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about" className="inline-block bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-900 transition-all shadow-lg whitespace-nowrap cursor-pointer">
              Our Story →
            </Link>
          </div>

          {/* Image - Right */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/b15d1996f87f30e0f45e4cc33485f69b.jpg"
                alt="ScapeWorx founder"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}